import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";

const Help = () => {
  const contactInfo = [
    { icon: "pi pi-user", label: "Име", value: "Венко Андонов" },
    {
      icon: "pi pi-envelope",
      label: "Имейл",
      value: "vgandonov@gmail.com",
      link: "mailto:vgandonov@gmail.com",
    },
    { icon: "pi pi-phone", label: "Телефон", value: "+359 893 811 488", link: "tel:+359893811488" },
    { icon: "pi pi-user", label: "Име", value: "Сали Салиев" },
    {
      icon: "pi pi-envelope",
      label: "Имейл",
      value: "salisalievb@gmail.com",
      link: "mailto:salisalievb@gmail.com",
    },
    { icon: "pi pi-phone", label: "Телефон", value: "+359 877 943 553", link: "tel:+359877943553" },
  ];

  const changelog = [
    {
      dateTime: "2025-11-09 18:15:52",
      date: "2025-11-09",
      time: "18:15",
      description: "Поправки в отчетите за групи и свързани функционалности",
      changes: [
        "Коригирани проблеми в генерирането на отчети за групи",
        "Оптимизиране на API заявките за групови данни",
        "Поправки в експорта на Excel файлове",
      ],
    },
    {
      dateTime: "2025-11-06 00:11:50",
      date: "2025-11-06",
      time: "00:11",
      description: "Добавена експериментална интеграция с Userback",
      changes: [
        "Интеграция с Userback за обратна връзка от потребители",
        "Добавен Userback клиент и middleware",
        "Подобрена система за обработка на потребителска обратна връзка",
      ],
    },
    {
      dateTime: "2025-11-05 23:26:56",
      date: "2025-11-05",
      time: "23:26",
      description: "Подобрения във форматирането и навигацията",
      changes: [
        "Подобрени формати за дати в цялата система",
        "Инициализация на страницата за помощ",
        "Запазване на филтрите при навигация в списъка с протоколи",
        "Оптимизации в навигацията между страници",
      ],
    },
    {
      dateTime: "2025-10-17 12:43:43",
      date: "2025-10-17",
      time: "12:43",
      description: "Подобрения в системата за записване",
      changes: [
        "Подобрения в системата за записване на магистри",
        "Добавена възможност за изчистване на предишно образование",
        "Оптимизиране на процеса на записване",
      ],
    },
    {
      dateTime: "2025-10-04 19:08:00",
      date: "2025-10-04",
      time: "19:08",
      description: "Разширения в системата за записване и протоколи",
      changes: [
        "Подобрения в избора на подспециалности при записване",
        "Добавена поддръжка за визови данни",
        "Включена академична година при генериране на протоколи по план",
        "Оптимизации в процеса на генериране на протоколи",
      ],
    },
  ];

  const instructions = [
    {
      title: "Основна информация",
      icon: "pi pi-play",
      steps: [
        { text: "Вход и потребители на системата", link: "#" },
        { text: "Записване на студенти", link: "#" },
        { text: "Редактиране на студенти", link: "#" },
        { text: "Синхронизиране с НАЦИД", link: "#" },
      ],
    },
    {
      title: "Учебни планове и протоколи",
      icon: "pi pi-calendar",
      steps: [
        { text: "Редактиране и създаване на учебните планове", link: "#" },
        { text: "Свързване на учебните планове със студентите", link: "#" },
        { text: "Методи за създаване на протоколи", link: "#" },
        { text: "Създаване на протоколи за признаване на оценки", link: "#" },
      ],
    },
    {
      title: "Други",
      icon: "pi pi-chart-bar",
      steps: [
        { text: "Изпращане на обратна връзка с допълнителна информация", link: "#" },
        { text: "Инструкции за преподавателите", link: "#" },
        { text: "-", link: "#" },
        { text: "-", link: "#" },
      ],
    },
  ];

  return (
    <div className="p-4">
      <h1 className="mb-4 mt-0 text-4xl font-light">Помощна информация</h1>

      <div className="grid">
        {/* Contact Information */}
        {Array.from({ length: Math.ceil(contactInfo.length / 3) }, (_, i) => {
          const personContacts = contactInfo.slice(i * 3, (i + 1) * 3);
          return (
            <div key={i} className="col-12 md:col-3">
              <Card title={`Контакт ${i + 1}`} className="h-full">
                <div className="space-y-3">
                  {personContacts.map((contact, index) => (
                    <div key={index} className="flex align-items-center gap-3 mb-2">
                      <i className={`${contact.icon} text-2xl text-primary`}></i>
                      <div className="flex-1">
                        <div className="font-medium text-sm text-600">{contact.label}</div>
                        {contact.link ? (
                          <a href={contact.link} className="text-primary hover:text-primary-600 no-underline">
                            {contact.value}
                          </a>
                        ) : (
                          <div className="text-900">{contact.value}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          );
        })}

        {/* Report Issues - Google Sheet */}
        <div className="col-12 md:col-2">
          <Card title="Докладване на проблеми (споделен Google Sheet)" className="h-full">
            <div className="space-y-4">
              <div className="text-center">
                <p className="text-700 mb-4">
                  Използвайте споделения Google Sheet за докладване на проблеми и предложения за подобрения:
                </p>
              </div>

              <Button
                label="Отвори Google Sheet"
                icon="pi pi-external-link"
                className="w-full p-button-primary"
                onClick={() =>
                  window.open(
                    "https://docs.google.com/spreadsheets/d/1IrR3gTJxPvSSYuBSG4HdxmlesSu9k7CeIsZHKhFJJ18/edit?gid=0#gid=0",
                    "_blank",
                  )
                }
              />

              <Divider />

              <div className="text-center text-sm text-600">
                <p>
                  <i className="pi pi-info-circle mr-2"></i>
                  Преди да докладвате проблем, проверете дали вече е известен в списъка с проблеми
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Report Issues - Userback */}
        <div className="col-12 md:col-2">
          <Card title="Докладване на проблеми (Userback)" className="h-full">
            <div className="space-y-4">
              <div className="text-center">
                <p className="text-700 mb-4">
                  Използвайте Userback за интерактивно докладване на проблеми с визуални елементи:
                </p>
              </div>

              <Button
                label="Отвори Userback"
                icon="pi pi-comments"
                className="w-full p-button-secondary"
                onClick={() => {
                  // Trigger Userback widget
                  if (window.Userback) {
                    window.Userback.open();
                  }
                }}
              />

              <Divider />

              <div className="text-center text-sm text-600">
                <p>
                  <i className="pi pi-lightbulb mr-2"></i>
                  Userback позволява снимане на екрана и добавяне на коментари към проблема
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* Instructions */}
      <div className="mt-4">
        <Panel header="Инструкции и помощни материали" toggleable collapsed={false}>
          <div className="grid">
            {instructions.map((instruction, index) => (
              <div key={index} className="col-12 md:col-4">
                <Card className="h-full">
                  <div className="text-center mb-3">
                    <i className={`${instruction.icon} text-4xl text-primary mb-2 block`}></i>
                    <h5 className="mt-0 mb-3">{instruction.title}</h5>
                  </div>

                  <ol className="pl-3 space-y-2">
                    {instruction.steps.map((step, stepIndex) => (
                      <li key={stepIndex}>
                        {step.link ? (
                          <a
                            href="#"
                            className="text-primary hover:text-primary-600 text-sm no-underline cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              // Navigate to the link
                              window.location.href = step.link;
                            }}
                          >
                            {step.text}
                          </a>
                        ) : (
                          <span className="text-700 text-sm">{step.text}</span>
                        )}
                      </li>
                    ))}
                  </ol>
                </Card>
              </div>
            ))}
          </div>
        </Panel>
      </div>

      {/* Changelog */}
      <div className="mt-4">
        <Panel header="История на промените в ТРУСИС" toggleable collapsed={false}>
          <div className="space-y-2">
            {changelog.map((entry, index) => (
              <Card key={index} className="border-left-3 border-primary">
                <div className="flex align-items-start justify-content-between mb-3">
                  <div className="flex-1">
                    <div className="flex align-items-center gap-2 mb-2">
                      <i className="pi pi-calendar text-primary text-lg"></i>
                      <div>
                        <span className="font-medium text-primary">{entry.date}</span>
                        <span className="text-600 ml-2">{entry.time}</span>
                      </div>
                    </div>
                    <h6 className="mt-0 mb-1 text-900 font-medium">{entry.description}</h6>
                  </div>
                  <i className="pi pi-clock text-primary"></i>
                </div>

                <ul className="pl-3 space-y-1">
                  {entry.changes.map((change, changeIndex) => (
                    <li key={changeIndex} className="text-700 text-sm">
                      {change}
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default Help;
